import { colors, spacing, typography } from '../tokens';
export const layoutStyles = {
    pageContainer: {
        minHeight: '100vh',
        backgroundColor: colors.gray[50],
        padding: spacing[5],
        fontFamily: typography.fontFamily.sans,
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    flexBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: spacing[4],
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[2],
        paddingBottom: spacing[2],
        borderBottom: `1px solid ${colors.gray[100]}`,
    },
};
export const textStyles = {
    heading: {
        fontSize: typography.fontSize['2xl'],
        fontWeight: typography.fontWeight.bold,
        color: colors.gray[900],
        fontFamily: typography.fontFamily.sans,
        lineHeight: typography.lineHeight.tight,
    },
    subheading: {
        fontSize: typography.fontSize.md, // Reduced from lg for tighter layout
        fontWeight: typography.fontWeight.semibold,
        color: colors.gray[900],
        fontFamily: typography.fontFamily.sans,
        lineHeight: typography.lineHeight.tight,
    },
    body: {
        fontSize: typography.fontSize.base,
        color: colors.gray[600],
        fontFamily: typography.fontFamily.sans,
        lineHeight: typography.lineHeight.normal,
    },
    caption: {
        fontSize: typography.fontSize.base, // Slightly larger for readability
        color: colors.gray[600],
        fontFamily: typography.fontFamily.sans,
    },
    muted: {
        fontSize: typography.fontSize.base,
        color: colors.gray[400],
        fontStyle: 'italic',
        fontFamily: typography.fontFamily.sans,
    },
};
//# sourceMappingURL=layout.js.map